import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import { securityAuthenticationReducers, securityAuthenticationWatchers } from './authentication';
import { securityInvitationsReducers, securityInvitationsWatchers } from './invitations';
import { securityMcpOAuthApproveReducers, securityMcpOAuthApproveWatchers } from './mcp-oauth';
import { securityOidcConfigurationsReducers, securityOidcConfigurationsWatchers } from './oidc-configurations';
import { securitySwitchOrganizationReducers, securitySwitchOrganizationWatchers } from './switch-organization';

export const securityReducers = combineReducers({
	authentication: securityAuthenticationReducers,
	invitations: securityInvitationsReducers,
	mcp: securityMcpOAuthApproveReducers,
	oidcConfigurations: securityOidcConfigurationsReducers,
	switchOrganization: securitySwitchOrganizationReducers
});

export const securityWatchers = combineAllWatchers([
	securityAuthenticationWatchers,
	securityInvitationsWatchers,
	securityOidcConfigurationsWatchers,
	securityMcpOAuthApproveWatchers,
	securitySwitchOrganizationWatchers
]);
